module.exports = __webpack_public_path__ + "img/check.3c74afa9.svg";